<div class="pro-details acco-header">
  <span class="name not-mobile">{{admin?'Admin': fullName || userDetails?.userName }}</span>

  <div class="profile-img" (click)="onThemeClick($event)"></div>

  <div class="header">
    <div class="apps-icon" (click)="toggleShowApps($event)"></div>
  </div>
</div>

@if (showThemes) {
<div class="dropdown">
  <!-- <div class="pro-details" (click)="onViewProfile()">
    <span class="name">View Profile</span>
  </div> -->
  <div class="pro-details" (click)="logout($event)">
    <span class="name">Logout</span>
  </div>
</div>
}

@if (showApps) {
<div #popup class="all-apps">
  <div class="all-apps-container">
    <div class="app-image-container" (click)="clickApps(orgUrl)">
      <img src="assets/Images/org-icon.svg" alt="Org" />
    </div>
    <!-- <div class="app-image-container" (click)="clickApps(accoUrl)">
      <img src="assets/Images/acco-icon.svg" alt="Accomodation" />
    </div> -->
    <!-- Uncomment if needed -->
    <!-- <div class="app-image-container" (click)="clickApps(onlineIvUrl)">
        <img src="assets/Images/phil-icon.svg" alt="Phil" />
      </div> -->
  </div>
</div>
}